import { render, staticRenderFns } from "./HeaderBody.vue?vue&type=template&id=77bcb351&scoped=true&"
import script from "./HeaderBody.vue?vue&type=script&lang=js&"
export * from "./HeaderBody.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBody.vue?vue&type=style&index=0&id=77bcb351&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bcb351",
  null
  
)

export default component.exports